module.exports = __webpack_public_path__ + "static/media/add-grey.73faf0d3.svg";